import { memo } from 'react';
import { S3, S4 } from '../../theme';
import type { IIconProps } from '../interfaces';

interface RadioIconProps extends Omit<IIconProps, 'color'> {
  disabled?: boolean | undefined,
}

const RadioIcon = (props: RadioIconProps) => {
  const { width = 16, height = 16, disabled = false } = props;
  const stroke = disabled ? S3 : S4;

  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7.5" transform="rotate(-90 8 8)" stroke={stroke} />
    </svg>
  );
};

export default memo(RadioIcon);
